import React from 'react';

import { FilteredProductList } from '../Components/ProductFilters/FilteredProductList';
import { Props } from './Types';

// eslint-disable-next-line
declare let global: any;

const Components: Record<string, typeof React.Component | React.FC<Props>> = {
    FilteredProductList: FilteredProductList
};

// register components as global required by ReactJS.NET
for (const component in Components) {
    global[component] = Components[component];
}
